import usePosModal from "@/shared/atoms/usePosModal";
import PosOrderSide from "../PosOrder/PosOrderSide";

const LivePos = () => {
  const [isPosOrderOpen, setIsPosOrderOpen] = usePosModal();
  return isPosOrderOpen ? (
    <PosOrderSide
      active={isPosOrderOpen}
      onExit={() => setIsPosOrderOpen(false)}
    />
  ) : null;
};

export default LivePos;
